import React from 'react';
import './ValidationModal.css'; // Reutilizando os estilos do ValidationModal

const OperatorModal = ({ operatorType, onClose }) => {
  if (!operatorType) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="validation-modal-backdrop" onClick={handleBackdropClick}>
      <div className="validation-modal">
        <div className="validation-modal-header">
          <h3>❌ Operador não pode ser usado como nó independente</h3>
          <button className="validation-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="validation-modal-content">
          <p className="validation-modal-description">
            O operador <strong>&ldquo;{operatorType}&rdquo;</strong> só pode ser usado dentro de outros nós como parte de expressões.
          </p>
          
          <div className="validation-modal-list">
            <div className="validation-item">
              <div className="validation-item-header">
                <span className="validation-item-number">📝</span>
                <span className="validation-item-title">Como usar operadores:</span>
              </div>
              <ul className="validation-item-pendencies">
                <li><strong>1️⃣ Arraste um nó que aceita expressões:</strong>
                  <ul style={{ marginLeft: '20px', marginTop: '5px' }}>
                    <li>• &ldquo;Decidir&rdquo; (para condições)</li>
                    <li>• &ldquo;Repetir&rdquo; (para loops condicionais)</li>
                    <li>• &ldquo;Atribuir&rdquo; (para cálculos)</li>
                  </ul>
                </li>
                <li><strong>2️⃣ Dentro do campo de condição/expressão do nó:</strong>
                  <ul style={{ marginLeft: '20px', marginTop: '5px' }}>
                    <li>• Arraste o operador desejado</li>
                    <li>• Configure os valores da expressão</li>
                    <li>• Conecte com variáveis se necessário</li>
                  </ul>
                </li>
                <li><strong>🔧 Lembre-se:</strong> Operadores são <em>componentes</em> de expressões, não ações independentes no fluxograma.</li>
                <li><strong>💡 Exemplo:</strong> Use &ldquo;2 + 3&rdquo; dentro de um nó &ldquo;Atribuir&rdquo;, não como nó solto.</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="validation-modal-footer">
          <button className="validation-modal-button primary" onClick={onClose}>
            Entendi
          </button>
        </div>
      </div>
    </div>
  );
};

export default OperatorModal;
